import PolicyOverviewStatusField from '@acorn-portal/shared/src/components/status/policyOverviewStatusField';
import { PolicyOverview, PolicyStatus } from '@acorn-portal/shared/src/services/api';
import { DISPLAY_DATE_TIME } from '@acorn-portal/shared/src/utils/constants';
import { Box, ButtonBase, Paper, Typography } from '@mui/material';
import { format } from 'date-fns';
import { FC } from 'react';

import { getVehicleIconByProduct } from '@acorn-portal/shared/src/utils/constants/vehicleIcons';

interface IRenewalListItemProps {
	policy: PolicyOverview;
	onSelect: (policyToken: string, policyNumber: string) => void;
}
const RenewalListItem: FC<IRenewalListItemProps> = ({ policy, onSelect }) => {
	return (
		<Paper
			sx={(theme) => ({
				alignContent: 'left',
				textAlign: 'left',
				marginTop: '2rem',
				padding: '20px',
				borderRadius: '8px',
				backgroundColor: '#fefefefe',
				cursor: 'pointer',
				transition: '0.4s',
				border: `1px solid ${theme.palette.divider}`,
				'&:hover': {
					backgroundColor: 'rgba(78, 85, 162, 0.12)',
				},
			})}
		>
			<ButtonBase
				sx={{ textAlign: 'left', width: { xs: '100%', sm: 'auto' } }}
				onClick={() => onSelect(policy.policyToken, policy.policyNumber)}
			>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						flexDirection: { xs: 'column', sm: 'row' },
						width: { xs: '100%', sm: 'auto' },
					}}
				>
					{' '}
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							width: { xs: '100%', sm: '20em' },
							margin: '0 auto',
							svg: {
								margin: { xs: '0 auto 2em', sm: '0 auto', width: '120px' },
							},
						}}
					>
						{getVehicleIconByProduct(policy.product, 'large')}
					</Box>
					<Box>
						<PolicyOverviewStatusField policy={policy} />
						<Typography
							variant='h5'
							component='h5'
							sx={(theme) => ({
								color: theme.palette.secondary.main,
								fontSize: '1.6rem',
							})}
						>
							{policy.vehicleRegistrationNumber.toLocaleUpperCase()}
						</Typography>
						<Typography variant='body2' component='p' sx={{ fontSize: '1.1rem' }}>
							{policy.vehicleMakeModel}
						</Typography>
						{policy.policyStatus === PolicyStatus.Expired ||
						policy.policyStatus === PolicyStatus.Cancelled ||
						policy.policyStatus === PolicyStatus.Quote ? null : (
							<Typography variant='body2' component='p' sx={{ fontSize: '1.1rem' }}>
								Days of cover remaining: {policy.remainingDaysOfCover}
							</Typography>
						)}
						<Typography variant='body2' component='p' sx={{ fontSize: '1.1rem' }}>
							Policy Number: {policy.policyNumber}
						</Typography>
						<Typography variant='body2' component='p' sx={{ fontSize: '1.1rem' }}>
							{format(new Date(policy.startDate), DISPLAY_DATE_TIME)} -{' '}
							{format(new Date(policy.expiryDate), DISPLAY_DATE_TIME)}
						</Typography>
					</Box>
				</Box>
			</ButtonBase>
		</Paper>
	);
};

export default RenewalListItem;
